import { render, staticRenderFns } from "./b-dropdown-wrapper.vue?vue&type=template&id=a2e30d88&"
import script from "./b-dropdown-wrapper.vue?vue&type=script&lang=js&"
export * from "./b-dropdown-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./b-dropdown-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports